import React from 'react'
import { connect } from 'react-redux';
import { formatarReal } from '../../util/numberUtil';
import DetalheEncomenda from './DetalheEncomenda';
import alterarExibicaoEncomenda from '../../actions/encomenda/alterarExibicaoEncomenda';
import AcoesEncomenda from './AcoesEncomenda';
import ReactTooltip from 'react-tooltip';
import { mapSituacaoTransmissaoCteOs, situacaoTransmissaoCteOs } from '../../util/constantsUtil';

export class Encomenda extends React.Component {

  getEncomendaBadgeClass(situacao) {
    if (!situacao) return 'vx-gp-badge--default';
    const s = situacao.toUpperCase();
    if (s.includes('APROVADO') || s.includes('ENTREGUE') || s.includes('CONFIRMADO')) return 'vx-gp-badge--aprovado';
    if (s.includes('CANCELADO') || s.includes('RECUSADO')) return 'vx-gp-badge--cancelado';
    if (s.includes('PENDENTE') || s.includes('ABERTO') || s.includes('AGUARDANDO') || s.includes('TR')) return 'vx-gp-badge--pendente';
    return 'vx-gp-badge--default';
  }

  exibirIconeMotivoErro(historico) {
    if (historico != null && historico.situacaotransmissao.chave === situacaoTransmissaoCteOs.erro) {
      const motivo = historico.motivo ? historico.motivo.replace(/Rejeição: /, '') : ''
      const tooltipId = `cte-os-${historico.id}-${this.props.encomenda.id}`
      return (
        <span style={{ marginLeft: 4, display: 'inline-flex', alignItems: 'center' }}>
          <a data-tip data-for={tooltipId}>
            <span className="material-icons" style={{ fontSize: 16, color: '#e53935', cursor: 'pointer' }}>info</span>
          </a>
          <ReactTooltip id={tooltipId} type="dark" effect="solid">
            <span>{motivo}</span>
          </ReactTooltip>
        </span>
      )
    }
    return null
  }

  render() {
    const { encomenda } = this.props
    const isOpen = encomenda.exibirDetalhe;
    return (
      <div className={`vx-gp-row${isOpen ? ' vx-gp-row--open' : ''}`}>
        <div className="vx-gp-row-main vx-gp-row-main--encomenda">
          <div className="vx-gp-toggle" onClick={() => this.props.alterarExibicaoEncomenda(encomenda)}>
            <span className="material-icons">{isOpen ? 'expand_less' : 'expand_more'}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Nº Pedido</span>
            <span className="vx-gp-field-value">#{encomenda.idPedido}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Vendedor</span>
            <span className="vx-gp-field-value">{encomenda.nomeVendedor}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Descrição</span>
            <span className="vx-gp-field-value">{encomenda.descricaoProduto}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Remetente</span>
            <span className="vx-gp-field-value">{encomenda.remetente.nome}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Destinatário</span>
            <span className="vx-gp-field-value">{encomenda.destinatario.nome}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Situação Ct-e</span>
            <span className="vx-gp-field-value">
              {encomenda.ultimoHistoricoEmissaoCte == null
                ? <span style={{ color: '#aaa', fontSize: 12 }}>Não transmitido</span>
                : <span style={{ color: mapSituacaoTransmissaoCteOs.get(encomenda.ultimoHistoricoEmissaoCte.situacaotransmissao.chave).textColor }}>
                    {encomenda.ultimoHistoricoEmissaoCte.situacaotransmissao.valor}
                    {this.exibirIconeMotivoErro(encomenda.ultimoHistoricoEmissaoCte)}
                  </span>
              }
            </span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Status evento Ct-e</span>
            <span className="vx-gp-field-value">
              {encomenda.ultimoHistoricoEventoCte == null
                ? <span style={{ color: '#bbb' }}>—</span>
                : <span style={{ color: mapSituacaoTransmissaoCteOs.get(encomenda.ultimoHistoricoEventoCte.situacaotransmissao.chave).textColor }}>
                    {encomenda.ultimoHistoricoEventoCte.situacaotransmissao.valor}
                    {this.exibirIconeMotivoErro(encomenda.ultimoHistoricoEventoCte)}
                  </span>
              }
            </span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Data emissão</span>
            <span className="vx-gp-field-value">{encomenda.dataCriacao}</span>
          </div>
          <div className="vx-gp-field">
            <span className="vx-gp-field-label">Status pedido</span>
            <span className={`vx-gp-badge ${this.getEncomendaBadgeClass(encomenda.ultimoHistorico.descricaoSituacao)}`}>
              {encomenda.ultimoHistorico.descricaoSituacao}
            </span>
          </div>
          <div className="vx-gp-field vx-gp-field--price">
            <span className="vx-gp-field-label">Valor</span>
            <span className="vx-gp-field-value">{formatarReal(encomenda.valorTotal)}</span>
          </div>
          <div className="vx-gp-field vx-gp-field--actions">
            <AcoesEncomenda
              encomenda={encomenda}
              selecionarHistoricos={this.props.selecionarHistoricos}
              preencherModalImagensEncomenda={this.props.preencherModalImagensEncomenda}
              preencherModalInformarEntregaEncomenda={this.props.preencherModalInformarEntregaEncomenda}
            />
          </div>
        </div>
        <div style={{ padding: '2px 14px 8px', display: 'flex', gap: 16, fontSize: 12, color: '#888' }}>
          <span><strong style={{ color: '#555' }}>Origem:</strong> {encomenda.cidadeOrigem}</span>
          <span><strong style={{ color: '#555' }}>Destino:</strong> {encomenda.cidadeDestino}</span>
        </div>
        <DetalheEncomenda encomenda={encomenda} />
      </div>
    )
  }
}

export const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
});

export default connect(mapStateToProps, {
  alterarExibicaoEncomenda
})(Encomenda)
